export default {
  allServices: [],
}
